import { LayoutConst } from "core";
import styled from "styled-components";

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 160px 0 0 0;
  max-width: calc(100vw - 32px);
  position: relative;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    padding: 16px 16px 24px;
  }
`;
import { LayoutConst } from "core";
import styled from "styled-components";

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 160px 0 0 0;
  max-width: calc(100vw - 32px);
  position: relative;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    padding: 16px 16px 24px;
  }
`;
